<template>
  <div class="am-phone-number">
    <div class="am-phone-number__texts">
      <AmTypography
        class="am-phone-number__label"
        typography-style="l7"
        font-type="roboto"
        weight="medium"
        text-color="dark"
      >
        <label for="AmPhoneNumber">{{ label }}</label>
      </AmTypography>
      <AmTypography
        v-if="hint"
        class="am-phone-number__hint"
        typography-style="l7"
        font-type="roboto"
        weight="regular"
        text-color="error"
        :text="hint"
      />
    </div>
    <VuePhoneNumberInput
      id="AmPhoneNumber"
      v-model="modelEmitter"
      class="am-phone-number__phone"
      :translations="{
        countrySelectorLabel: '',
        countrySelectorError: '',
        phoneNumberLabel,
        example: 'Exemplo :',
      }"
      required
      :error="error"
      :default-country-code="defaultCountryCode"
      :only-countries="onlyCountries"
      @update="$emit('update', $event)"
      @phone-number-blur="$emit('blur', $event)"
    />
  </div>
</template>
<script>
import 'vue-phone-number-input/dist/vue-phone-number-input.css'
import VuePhoneNumberInput from 'vue-phone-number-input'

export default {
  name: 'AmPhoneNumber',
  components: { VuePhoneNumberInput },
  props: {
    value: {
      type: [String, Number],
    },
    phoneNumberLabel: {
      type: String,
    },
    defaultCountryCode: {
      type: String,
    },
    error: {
      type: Boolean,
    },
    hint: {
      type: String,
    },
    onlyCountries: {
      type: Array,
    },
    label: {
      type: String,
    },
  },
  computed: {
    modelEmitter: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
}
</script>
<style lang="scss" scoped>
.input {
  border: 1px solid $light-40;
  height: 42px;
  color: $dark-60;
}

.am-phone-number {
  margin-top: 20px;

  &__texts {
    display: flex;
    margin-bottom: 6px;
    justify-content: space-between;
  }
}

::v-deep .input-tel__input {
  @extend .input;
}

::v-deep .country-selector {
  &__input {
    @extend .input;
  }

  &__country-flag {
    top: 15px;
    left: 12px;
  }

  &__toggle {
    right: 4px;
    top: calc(50% - 13px);
  }

  &__toggle__arrow {
    color: $dark-60;
  }
}

::v-deep label {
  line-height: 16px;
  margin-bottom: 0;
}

::v-deep .vue-phone-number-input .select-country-container {
  flex: 0 0 90px;
  min-width: 90px;
}

::v-deep .country-selector.has-value .country-selector__input {
  padding-top: 0;
  padding-left: 33px;
}

::v-deep .input-tel.has-error:not(.is-valid) .input-tel__input {
  border-color: $error !important;
}

::v-deep .input-tel.is-valid .input-tel__input,
::v-deep .input-tel.is-valid .input-tel__input:hover,
::v-deep .country-selector.is-valid .country-selector__input {
  border-color: $success-80 !important;
}

::v-deep .input-tel.has-error .input-tel__input,
::v-deep .input-tel.is-focused .input-tel__input,
::v-deep .country-selector.input-country-selector.has-value .country-selector__input,
::v-deep .input-tel.is-valid .input-tel__label,
::v-deep .country-selector.is-valid .country-selector__input {
  box-shadow: unset !important;
}

::v-deep .input-tel.is-focused:not(.has-error, .is-valid) .input-tel__input,
::v-deep .input-tel.has-hint:not(.has-error) .input-tel__input,
::v-deep .country-selector.input-country-selector.has-value .country-selector__input {
  border-color: $light-40 !important;
}

::v-deep .input-tel.is-valid .input-tel__label {
  color: $success-80 !important;
}

::v-deep .input-tel.has-hint:not(.has-error) .input-tel__label {
  color: $dark-60 !important;
}
</style>
